import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Translate, getActiveLanguage } from "react-localize-redux"
// import { Gmaps, Marker } from "react-gmaps"

import BannerImage from "../../images/about-header@2x.png"
import Map1Image from "../../images/map-1.png"
import Map2Image from "../../images/map-2.png"
import Map3Image from "../../images/map-3.png"
import Map4Image from "../../images/map-4.png"
import Map5Image from "../../images/map-5.png"
import Map6Image from "../../images/map-6.png"
import Map7Image from "../../images/map-7.png"
import Map8Image from "../../images/map-8.png"
import Map9Image from "../../images/map-9.png"

const JFHOutlet = [
	{
		name: "Marks & Spencer Wheelock Place",
		image: Map1Image,
		address: ["501 Orchard Rd, #01-01,", "Wheelock Place,", "Singapore 238880"],
		email: "",
		phone: "+65 6733 8122",
		hours: " 10am-10pm daily",
		coords: {
			lat: 1.3045021,
			lng: 103.8283483,
		},
		href: "",
	},
	{
		name: "Marks & Spencer Paragon",
		image: Map2Image,
		address: [
			"290 Orchard Rd, #03-35/40,",
			"Paragon Shopping Centre,",
			"Singapore 238859",
		],
		email: "",
		phone: "+65 6732 9732",
		hours: "10:30am–10pm daily",
		coords: {
			lat: 1.3035658,
			lng: 103.8335831,
		},
		href: "",
	},
	{
		name: "Marks & Spencer Raffles City Shopping Centre",
		image: Map3Image,
		address: [
			"252 North Bridge Road, #02-01,",
			"Raffles City Shopping Centre, ",
			"Singapore 179103",
		],
		email: "",
		phone: "+65 6339 9013",
		hours: "10:30am–10pm daily",
		coords: {
			lat: 1.293611,
			lng: 103.8508275,
		},
		href: "",
	},
	{
		name: "Marks & Spencer Plaza Singapura",
		image: Map4Image,
		address: [
			"68 Orchard Rd, #02-16- 20 & #03-31-32, ",
			"Plaza Singapura,",
			"Singapore 238839",
		],
		email: "",
		phone: "+65 6835 9552",
		hours: "10:30am–10pm daily",
		coords: {
			lat: 1.3006375,
			lng: 103.8428006,
		},
		href: "",
	},
	{
		name: "Marks & Spencer Parkway Parade",
		image: Map5Image,
		address: ["80 Marine Parade Rd, #02-28-32,", "Singapore 449269"],
		email: "",
		phone: "+65 6348 1766",
		hours: "10:30am–10pm daily",
		coords: {
			lat: 1.3007756,
			lng: 103.9032771,
		},
		href: "",
	},
	{
		name: "Marks & Spencer Vivo City",
		image: Map6Image,
		address: ["1 Harbourfront Walk,", "#01-46, VivoCity", "Singapore 098585"],
		email: "",
		phone: "+65 6377 2022",
		hours: "10:30am–10pm daily",
		coords: {
			lat: 1.264613,
			lng: 103.820818,
		},
		href: "",
	},
	{
		name: "Marks & Spencer JEM",
		image: Map7Image,
		address: [
			"50 Jurong Gateway Road",
			"#02-24/25/26 & #03-27/28/29 Jurong East Mall Singapore 608549",
		],
		email: "",
		phone: "+65 6734 7440",
		hours: "10:30am–10pm daily",
		coords: {
			lat: 1.3326304,
			lng: 103.741004,
		},
		href: "",
	},
	{
		name: "Marks & Spencer Marina Square",
		image: Map8Image,
		address: [
			"6 Raffles Boulevard, #02-109-114 & #03-100-107",
			"Marina Square,",
			"Singapore 039594",
		],
		email: "",
		phone: "+65 6837 0962",
		hours: "10am–9:30pm daily",
		coords: {
			lat: 1.2918897,
			lng: 103.854638,
		},
		href: "",
	},
	{
		name: "Marks & Spencer Jewel Changi Airport",
		image: Map9Image,
		address: [
			"78 Airport Boulevard #B1-208/209/210/211",
			"Jewel Changi Airport Singapore 819666",
		],
		email: "",
		phone: "+65 6245 9225",
		hours: "10am – 10pm daily",
		coords: {
			lat: 1.3602672,
			lng: 103.9875507,
		},
		href: "",
	},
]

class AboutUs extends React.Component {
	render() {
		return (
			<div id="about">
				<section className="section-banner mx--3 mb-4">
					<img src={BannerImage} alt="About Banner" />
				</section>
				<div className="row justify-content-center mt-3">
					<div className="col-12 col-xl-11">
						{/* --- Page Content starts here --- */}

						<div className="row justify-content-center section mb-4 pb-4">
							<div className="text-center col-12 col-xl-8 col-lg-10 mb-2 mt-2">
								<h4 className="mb-3">
									<Translate id="aboutUs._howItWorksTitle" />
								</h4>

								<div className="font-sub">
									<Translate id="aboutUs._howItWorksMessage" />
								</div>
							</div>
						</div>
						<div className="row address justify-content-center section mb-4 pb-4">
							<div className="text-center col-12 col-xl-12 col-lg-12 mb-2 mt-2">
								<h4 className="text-center mb-3">
									<Translate id="aboutUs._whereToPurchase" />
								</h4>
								{JFHOutlet.map((outlet, id) => {
									return (
										<div className="mb-3">
											<h5>{outlet.name}</h5>
											<div className="row mt-3">
												<div className="col-12 col-md-6 col-lg-5 map">
													<img src={outlet.image} />
													{/* <Gmaps
														width={"22rem"}
														height={"22rem"}
														lat={outlet.coords.lat}
														lng={outlet.coords.lng}
														zoom={14}>
														<Marker
															lat={outlet.coords.lat}
															lng={outlet.coords.lng}
															draggable={true}
														/>
													</Gmaps> */}
												</div>
												<div className="col-12 col-md-6 col-lg-5 map-info">
													{outlet.address.map((address) => {
														return <p>{address}</p>
													})}
													<br />
													{outlet.email}
													{outlet.email && (
														<span>
															<br />Email: {outlet.email}
														</span>
													)}
													<br />Telp: {outlet.phone}
													<br />Hours: {outlet.hours}
													{outlet.href && (
														<span>
															<br />For more info, click }
															<a href={outlet.href}>
																here
															</a>.
														</span>
													)}
												</div>
											</div>
										</div>
									)
								})}
							</div>
						</div>
						<div className="row justify-content-center section mb-4 pb-4">
							<div className="text-center col-12 col-xl-8 col-lg-10 mb-2 mt-2">
								<h4 className="mb-3">
									<Translate id="aboutUs._corporateOrdersTitle" />
								</h4>

								<div className="font-sub">
									<p>
										<Translate id="aboutUs._corporateOrdersMessage._1" />
									</p>

									<p>
										<Translate id="aboutUs._corporateOrdersMessage._3" />
									</p>
								</div>
							</div>
						</div>
						<div className="row justify-content-center section mb-4 pb-4">
							<div className="text-center col-12 col-xl-12 col-lg-10 mb-4 mt-2">
								<h4 className="mb-3">
									<Translate id="aboutUs._faqTitle" />
								</h4>

								<div className="font-sub faq">
									<p className={"question"}>
										&bull; How much can I load on a Marks &amp;
										Spencer Gift Card?
									</p>
									<p className={"answer"}>
										Minimum Load: SGD 10<br />
										Maximum Load: SGD 2,000
									</p>
									<p className={"question"}>
										&bull; Where can I use my Marks &amp; Spencer Gift
										Card?
									</p>
									<p className={"answer"}>
										Marks &amp; Spencer Gift Card(s) are accepted
										across all Marks &amp; Spencer stores in
										Singapore, excluding M&amp;S Café at Wheelock
										Place, any pop-up stores and atrium events.<br />
										Click{" "}
										<a
											href="https://www.marksandspencer.com/sg/stores"
											target="_blank">
											here
										</a>{" "}
										to find out where you could shop using a Marks
										&amp; Spencer Gift Card in Singapore.
									</p>
									<p className={"question"}>
										&bull; What is the validity of a Marks &amp;
										Spencer Gift Card?
									</p>
									<p className={"answer"}>
										Marks &amp; Spencer Gift Card(s) are valid for a
										period of 12 months from date of issuance.
									</p>
									<p className={"question"}>
										&bull; Do I need to activate my Marks &amp;
										Spencer Gift Card prior to use?
									</p>
									<p className={"answer"}>
										It is strongly recommended to register your gift
										card prior to use. Once registered, you will be
										able to manage your Marks &amp; Spencer Gift
										Card(s) directly from your mobile device (i.e.,
										enquire for balances and/or mark your Marks &amp;
										Spencer Gift Card as Lost/Stolen).
									</p>
									<p className={"question"}>
										&bull; How could I enquire the balance on my Marks
										&amp; Spencer Gift Card(s)?
									</p>
									<p className={"answer"}>
										There are several avenues to check on the balances
										of your Marks &amp; Spencer Gift Card(s).
										<ul>
											<li>
												By using your smartphone to scan the QR
												code on the back of your Marks &amp;
												Spencer Gift Card
											</li>
											<li>
												By visiting{" "}
												<a
													href="http://www.marksandspencer.com/sg/stores"
													target="_blank">
													www.marksandspencer.com/sg/stores
												</a>{" "}
												and logging into your account{" "}
											</li>
											<li>
												Visit a Customer Service Desk at any Marks
												&amp; Spencer store in Singapore
											</li>
										</ul>
									</p>
									<p className={"question"}>
										&bull; Where do I find my 8-digit security code?
									</p>
									<p className={"answer"}>
										The 8-digit Marks &amp; Spencer Gift Card security
										code is required when you register your Gift Card
										online. The security code is protected by a
										security foil found on the reverse of your Marks
										&amp; Spencer Gift Card. Remove the security foil
										to access the code.
									</p>
									<p className={"question"}>
										&bull; My Marks &amp; Spencer Gift Card has
										expired – what should I do?
									</p>
									<p className={"answer"}>
										Marks &amp; Spencer Gift Card(s) are deemed
										invalid upon expiry of the cards. You may,
										however, avail of a grace period of 90 days from
										the expiry date for re-activation of your expired
										Marks &amp; Spencer Gift Card(s) upon successful
										payment of SGD 5 (as re-activation fee).<br />
										Please note that the existing balance on your
										Marks &amp; Spencer Gift Card needs to be more
										than SGD 5 to avail this facility and the
										re-activation fee will be deducted from the
										balance upon re-activation.<br />
										Use of our gift card constitutes acceptance of our{" "}
										<a
											href="https://www.marksandspencer.com/sg/customer-service/terms/terms.html"
											target="_blank">
											Terms & Conditions
										</a>.
									</p>
									<p className={"question"}>
										&bull; Can I get a refund for the available
										balance on the Marks &amp; Spencer Gift Card?
									</p>
									<p className={"answer"}>
										We do not offer refunds once funds have been
										loaded onto the card. The available balance can be
										utilized to make purchases across all Marks &amp;
										Spencer store in Singapore, during the validity
										and grace period (subject to successful
										re-activation).
									</p>
									<p className={"question"}>
										&bull; I have lost/had my Marks &amp; Spencer Gift
										Card stolen – what should I do?
									</p>
									<p className={"answer"}>
										If you have lost / had your Marks &amp; Spencer
										Gift Card stolen, please follow the following
										steps:
										<ul>
											<li>
												Login to your Marks &amp; Spencer Gift
												Card account and mark the card as
												lost/stolen. This action will block your
												Marks &amp; Spencer Gift Card.
											</li>
											<li>
												You will receive new virtual card as a
												replacement. There is a replacement fee of
												SGD 5 that will be deducted from the
												available balance on the Marks &amp;
												Spencer Gift Card at the time of
												re-placement.
											</li>
										</ul>
									</p>
									<p className={"question"}>
										&bull; How do I contact Customer Service?
									</p>
									<p className={"answer"}>
										All enquiries in connection with a Marks &amp;
										Spencer Gift Card should be made to the Customer
										Services Contact Centre by emailing
										mandssg.customerservice@alfuttaim.com.
									</p>
									<p className={"question"}>
										&bull; Can I use my Marks &amp; Spencer Gift Card
										for online transactions?
									</p>
									<p className={"answer"}>
										We are currently working towards activating
										acceptance of the Marks &amp; Spencer Gift Card on
										our eCommerce portal and would request you watch
										this space for more information.
									</p>
									<p className={"question"}>
										&bull; Can I re-load my Marks &amp; Spencer Gift
										Card?
									</p>
									<p className={"answer"}>
										Marks &amp; Spencer Gift Card(s) are not
										reloadable.
									</p>
								</div>
							</div>
						</div>

						{/* --- Page Content ends here --- */}
					</div>
				</div>
			</div>
		)
	}
}

AboutUs.propTypes = {
	currentLanguage: PropTypes.string.isRequired,
}

const mapStateToProps = ({ auth, locale }) => ({
	currentLanguage: getActiveLanguage(locale).code,
})

export default connect(mapStateToProps)(AboutUs)



// WEBPACK FOOTER //
// ./src/views/pages/About.js